import React from "react";
import { useSelector } from "react-redux";
export const ProgressBar = ({
  value = 45,
  progressStyle = {},
  mainStyle = {},
  goalAmount,isCard=false
}) => {
  const language = useSelector((state) => state.language.value);
  return (
    <div
      className={`w-full   flex ${
        language === "_ar" ? "flex-row-reverse " : ""
      } bg-btn_gray rounded-full relative ${mainStyle}`}
    >

{goalAmount==null && isCard && <div className="absolute  top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex  justify-center justify-items-center  flex-row items-center">
  <div className="flex  justify-center justify-items-center  flex-row items-center">
    <div className=" h-[25px] bg-primary rounded-xl text-[12px] justify-center text-white py-[3px] px-[12px] w-full flex-row items-center">
 {language==='_ar'?'التبرع المفتوح':'Open Donation'}
 </div>
  </div>

</div>
}
      {
        value==0 ?
        <div className=" text-xs text-gray-800  flex justify-center w-full text-center">
          {Math.round(value)} % 
          </div>:
            <div
            className={`bg-primary  text-xs font-F11 
              ${value<=70 ?` ${
              language === "_ar" ? "text-left " : "text-right"
            }   ` : "text-center" }
              
             text-white   md:p-0.5 p-1.5 leading-none rounded-full ${progressStyle}`}
            style={{ width: `${value?.toString()}%` }}
          > {Math.round(value)}% 
          </div>
      }
    
    </div>
  );
};
